/**
 * ชนิดข้อมูลกลางของ Wickhaven ใช้ร่วมกันทั้ง client และ server
 * ทุกไฟล์ JSON ใน src/data ต้องตรงกับชนิดในไฟล์นี้
 */
export const STAT_KEYS = ["STR", "AGI", "VIT", "INT", "DEX", "LUK"];
export const GENDERS = Object.freeze([
    { id: "female", label: "หญิง" },
    { id: "male", label: "ชาย" },
]);
export const DEFAULT_GENDER = "female";
/** รับค่าที่ client ส่งมาแล้วคืนเพศที่ใช้ได้จริง ไม่ใช่ก็คืนค่าเริ่มต้น */
export function parseGender(raw) {
    const v = String(raw ?? "");
    return GENDERS.some((g) => g.id === v) ? v : DEFAULT_GENDER;
}
export const RACE_NAMES = {
    plant: "พืช", insect: "แมลง", beast: "สัตว์", aquatic: "สัตว์น้ำ", undead: "อันเดด",
    spirit: "วิญญาณ", construct: "สิ่งประดิษฐ์", dragon: "มังกร", humanoid: "มนุษย์",
};
export const ELEMENT_NAMES = {
    neutral: "ไร้ธาตุ", earth: "ดิน", water: "น้ำ", fire: "ไฟ", wind: "ลม",
    poison: "พิษ", holy: "แสง", dark: "มืด", ice: "น้ำแข็ง",
};
export const WEAPON_TYPE_NAMES = Object.freeze({
    sword_1h: "ดาบมือเดียว",
    greatsword_2h: "ดาบใหญ่สองมือ",
    knuckle_2h: "สนับมือ",
    bow_2h: "ธนูสองมือ",
    dagger_1h: "มีดสั้นมือเดียว",
    staff_1h: "คทามือเดียว",
    staff_2h: "ไม้เท้าสองมือ",
    lantern_1h: "ตะเกียงมือเดียว",
    crossbow_1h: "หน้าไม้มือเดียว",
    shield: "โล่",
    buckler: "โล่เล็ก",
    tome: "คัมภีร์",
    orb: "ลูกแก้ว",
    quiver: "ซองลูกธนู",
    dagger_off: "มีดมือรอง",
});
export const EQUIP_SLOTS = Object.freeze([
    { id: "head", kind: "head", label: "หมวก", side: "l" },
    { id: "face", kind: "face", label: "ของบนหน้า", side: "r" },
    { id: "weapon", kind: "weapon", label: "อาวุธ", side: "l" },
    { id: "offhand", kind: "offhand", label: "มือรอง (โล่)", side: "r" },
    { id: "body", kind: "body", label: "เสื้อ", side: "l" },
    { id: "legs", kind: "legs", label: "กางเกง", side: "r" },
    { id: "feet", kind: "feet", label: "รองเท้า", side: "l" },
    { id: "ear1", kind: "ear", label: "ต่างหูซ้าย", side: "r" },
    // สามช่องสุดท้ายอยู่แถวล่างใต้รูป ข้างละ 4 ช่องจะได้สูงเท่ากันทั้งสองฝั่ง
    { id: "ear2", kind: "ear", label: "ต่างหูขวา", side: "wide" },
    { id: "special", kind: "special", label: "เครื่องประดับพิเศษ", side: "wide" },
    // ช่องนี้ไม่ได้อยู่ใน GDD ฉบับแรก เพิ่มทีหลัง (3 ต.ค. 2026)
    { id: "pet", kind: "pet", label: "สัตว์เลี้ยง", side: "wide" },
    { id: "wings", kind: "wings", label: "ปีก", side: "wide" },
]);
/** ชื่อไทยของความหายาก ใช้ในคำอธิบายของ */
export const RARITY_TH = Object.freeze({
    common: "ธรรมดา",
    fine: "ดี",
    rare: "หายาก",
    epic: "มหากาพย์",
    legend: "ตำนาน",
});
//# sourceMappingURL=types.js.map